import React from 'react';
import { Box, spacing, variant } from '@landr/maestro';
import styled from 'styled-components';

type SliceSpacing = 'base' | 'minimal' | 'none';

const sliceStyles = variant({
    prop: 'spacing',
    variants: {
        base: {
            paddingBottom: spacing('mg'), // 72px
        },
        minimal: {
            paddingBottom: spacing('jb'), // 48px
        },
        none: {
            paddingBottom: 'none',
        },
    },
});

const Wrapper = styled(Box)<{ spacing: SliceSpacing }>`
    position: relative;
    width: 100%;

    ${sliceStyles};
`;

const Slice: React.FC<{ spacing?: SliceSpacing }> = ({
    children,
    spacing = 'base',
}) => (
    <Wrapper data-component="Slice" spacing={spacing}>
        {children}
    </Wrapper>
);

export default Slice;
